import React from 'react'
import { useGetRoute } from '@/lib/react-query'
import Typography from '@/components/ui/Typography'
import Input from '@/components/ui/Input'
import CopyAdornment from '@/components/ui/CopyAdornment'
import { formatSecureValue } from '@/utils/string'
import { useRouteEntryPoint } from '@/hooks/useRouteEntryPoint'
import classes from './DeployButton.module.scss'
import NoAuthAlert from '@/components/DeployButton/NoAuthAlert'

export type HttpDeployInstructionsProps = { projectId: number; routeId: number }

const HttpDeployInstructions = ({ projectId, routeId }: HttpDeployInstructionsProps) => {
  const {
    data: { route },
  } = useGetRoute(projectId, routeId)
  const routeUrl = useRouteEntryPoint(projectId, routeId)

  return (
    <div className={classes.httpRoot}>
      <div className={'d-grid gap-1'}>
        <Typography>1. Copy the URL below to use as the route in your system:</Typography>
        <Input value={routeUrl} disabled endAdornment={<CopyAdornment value={routeUrl} />} />
      </div>
      {route.authEnabled ? (
        <div className={'d-grid gap-1'}>
          <Typography>
            2. Copy the API token provided below and add it to your request headers as &apos;X-API-Key&apos;:
          </Typography>
          <Input
            value={formatSecureValue(route.apiKey)}
            disabled
            endAdornment={<CopyAdornment value={route.apiKey ?? ''} />}
          />
        </div>
      ) : (
        <NoAuthAlert projectId={projectId} routeId={routeId} />
      )}
    </div>
  )
}

export default HttpDeployInstructions
